// Auto generated file, do not manually modify!
// com.hotpads.leasing.api.web.v1.completion.LeaseCompletionWebApiHandler

import type { QueryOptions, UseQueryOptions } from '@zg-rentals/react-query5';
import { useQuery } from '@zg-rentals/react-query5';
import { tsClientOptions } from '@zg-rentals/react-query5';
import type { Client } from '@zg-rentals/http-client';
import {
  LeaseCompletionWebApiHandler_getCompletionStatus,
  LeaseCompletionWebApiHandler_getCompletionStatus_Path,
} from '@zg-rentals/ts-leasing-client';

import type { GetCompletionStatusResponseDto } from '@zg-rentals/ts-leasing-client';

interface GetCompletionStatusParams {
  leaseId: number;
}

export type LeaseCompletionWebApiHandler_getCompletionStatus_Options = UseQueryOptions<
  GetCompletionStatusResponseDto,
  unknown,
  GetCompletionStatusResponseDto,
  readonly [string, GetCompletionStatusParams]
>;

const LeaseCompletionWebApiHandler_getCompletionStatus_GetKey = (getParams: GetCompletionStatusParams) =>
  [LeaseCompletionWebApiHandler_getCompletionStatus_Path, getParams] as const;

export const LeaseCompletionWebApiHandler_getCompletionStatus_queryOptions = (
  getParams: GetCompletionStatusParams,
  { httpClient }: { httpClient?: Client } = {},
) =>
  ({
    ...tsClientOptions.queryOptions,
    queryKey: LeaseCompletionWebApiHandler_getCompletionStatus_GetKey(getParams),
    queryFn: () => LeaseCompletionWebApiHandler_getCompletionStatus(getParams, httpClient),
  }) as const satisfies QueryOptions;

/**
 * get the completion status for lease
 */
export const useLeaseCompletionWebApiHandler_getCompletionStatus = (
  getParams: GetCompletionStatusParams,
  {
    httpClient,
    ...options
  }: Omit<LeaseCompletionWebApiHandler_getCompletionStatus_Options, 'queryFn' | 'queryKey'> & {
    httpClient?: Client;
  } = {},
) => {
  return useQuery({
    ...LeaseCompletionWebApiHandler_getCompletionStatus_queryOptions(getParams, { httpClient }),
    ...options,
  });
};
useLeaseCompletionWebApiHandler_getCompletionStatus.getKey = LeaseCompletionWebApiHandler_getCompletionStatus_GetKey;
